<!-- Brand Logo -->
<a class="brand-link" style="background-color: #4e89f1">
  <pf-image
    alt="AdminLTE Logo"
    src="assets/img/CMS-logo.png"
    width="145"
  ></pf-image>
  <span class="brand-text font-weight-light text-center" style="color: #4e89f1">VarNik</span>
</a>
<!-- Sidebar -->
<div class="sidebar">
  <!-- Sidebar user (optional) -->
  <!--<div class="user-panel mt-3 pb-3 mb-3 d-flex">
    <div class="image">
      <pf-image
        [src]="user.picture"
        alt="User Image"
        class="img-circle"
        fallback-src="assets/img/default-profile.png"
        height="34"
        rounded
        width="34"
      ></pf-image>
    </div>
    <div class="info">
      <a [routerLink]="['/profile']" class="d-block">
        {{ user.email }}
      </a>
    </div>
  </div>-->

  <!--<div class="form-inline">
    <app-sidebar-search></app-sidebar-search>
  </div>-->

  <!-- Sidebar Menu -->
  <nav class="mt-2" style="overflow-x: hidden">
    <ul
      class="nav nav-pills nav-sidebar flex-column font-weight-bolder"
      data-accordion="false"
      data-widget="treeview"
      role="menu"
    >
      <app-menu-item
        *ngFor="let item of menu"
        [menuItem]="item"
      ></app-menu-item>
    </ul>
  </nav>
</div>
